<template>
    <div>
        <button class="btn btn-sm btn-dark mb-1" v-on:click="back">
            <feather-icon icon="ArrowLeftIcon" class="mr-25"></feather-icon>Geri
        </button>
        <b-overlay :show="loading" opacity="1">
            <b-card>
                <div class="row mb-1 align-items-center">
                    <div class="col-md-auto">
                        <div class="h3 d-inline-block font-weight-bolder bg-light-primary px-50 py-25 mb-0 mb-md-0 mb-1 rounded">{{$safe(detail,'AgreementCode') || '-'}}</div>
                        <div class="h3 d-inline-block font-weight-bolder ml-50 px-50 py-25 mb-0">{{$safe(detail,'FirmName') || '-'}}</div>
                    </div>
                    <div class="col-md">
                        <div class="d-flex align-items-center w-100 justify-content-end">
                            <span class="h3 font-weight-bolder text-muted ml-md-50 ml-0 mb-0">{{$safe(detail,'FirmLocationName') || '-'}}</span>
                            <span class="material-icons-round text-dark ml-25 mb-25">where_to_vote</span>
                        </div>
                    </div>
                </div>
                <hr />
                <div class="row">
                    <div class="col-md-6">
                        <div class="alert alert-secondary">
                            <div class="alert-body">
                                <h5>Sözleşme Başlangıç Tarihi</h5>
                                <h4 class="mb-0 font-weight-bolder text-secondary">{{$safe(detail,'StartDate') || '-'}}</h4>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="alert alert-danger">
                            <div class="alert-body">
                                <h5>Sözleşme Bitiş Tarihi</h5>
                                <h4 class="mb-0 font-weight-bolder text-danger">{{$safe(detail,'EndDate') || '-'}}</h4>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="alert alert-dark">
                    <div class="alert-body">
                        <h5>Vade (Gün)</h5>
                        <div class="row align-items-center">
                            <div class="col-md-auto pr-md-0">
                                <h4 class="mb-0 font-weight-bolder text-dark mr-50">{{$safe(detail,'Maturity') || '-'}}</h4>
                            </div>
                            <div class="col-md-auto pl-md-0">
                                (Ödeme, fatura kesildikten sonraki {{$safe(detail,'Maturity') || '-'}} gün içinde ödeme yapılmalı.)
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <div class="alert border">
                            <div class="alert-body">
                                <h5>Yakıt Artış/Azalış Oranı (%)</h5>
                                <h4 class="mb-0 font-weight-bolder text-dark mr-50">{{$safe(detail,'FuelPriceChangeRate')|| '-'}}</h4>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="alert border">
                            <div class="alert-body">
                                <h5>Enflasyon Uygulama Süresi (Ay)</h5>
                                <h4 class="mb-0 font-weight-bolder text-dark mr-50">{{$safe(detail,'InflationChangeDuration')|| '-'}}</h4>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-6">
                        <div class="alert border mb-lg-0 mb-1">
                            <div class="alert-body">
                                <h5>Yakıt</h5>
                                <h4 class="mb-0 font-weight-bolder text-dark">
                                    {{$safe(detail,'FuelPriceBaseDistrictName') || '-'}}/{{$safe(detail,'FuelPriceBaseProvinceName') || '-'}} - {{$safe(detail,'FuelPriceBaseFuelBrandName') || '-'}}
                                </h4>
                                <template v-if="$safe(detail,'FuelPriceHistories') && detail.FuelPriceHistories.length > 0">
                                    <ul class="list-group mt-1">
                                        <li class="list-group-item p-0" v-if="detail.FuelPriceHistories.length > 1">
                                            <agreement-detail-price-history-graph :prices="detail.FuelPriceHistories"></agreement-detail-price-history-graph>
                                        </li>
                                        <li v-for="price in detail.FuelPriceHistories" :key="price.Id" class="list-group-item">
                                            <div class="d-flex align-items-center">
                                                <span class="material-icons-round text-danger" v-if="price.HistoryRateStatus == 1">trending_down</span>
                                                <span class="material-icons-round text-success" v-if="price.HistoryRateStatus == 0">moving</span>
                                                <span class="material-icons-round text-dark" v-if="price.HistoryRateStatus == 2 || price.HistoryRateStatus == null">trending_flat</span>
                                                <span class="text-muted ml-1">{{price.Date}}</span>
                                                <span class="ml-1 mr-50">{{price.Price}} TL</span>
                                                <span class="mr-50 change-rate" :class="price.ChangeRate < 0 ? 'text-danger': price.ChangeRate > 0 ? 'text-success' : 'text-dark'">{{price.ChangeRate}}%</span>
                                                <span class="material-icons-round text-primary" v-if="price.IsLastUpdated">verified</span>
                                            </div>
                                        </li>
                                    </ul>
                                </template>
                                <template v-else>
                                    <ul class="list-group mt-1">
                                        <li class="list-group-item">Fiyat değişimi bulunmamaktadır.</li>
                                    </ul>
                                </template>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="alert border mb-0">
                            <div class="alert-body">
                                <h5>Enflasyon</h5>
                                <h4 class="mb-0 font-weight-bolder text-dark">TÜFE - ÜFE</h4>
                                <template v-if="$safe(detail,'InflationHistories') && detail.InflationHistories.length > 0">
                                    <ul class="list-group mt-1">
                                        <li class="list-group-item" v-for="inflation in detail.InflationHistories" :key="inflation.Id">
                                            <div class="d-flex align-items-center">
                                                <span class="material-icons-round text-danger" v-if="inflation.HistoryRateStatus == 1">trending_down</span>
                                                <span class="material-icons-round text-success" v-if="inflation.HistoryRateStatus == 0">moving</span>
                                                <span class="material-icons-round text-dark" v-if="inflation.HistoryRateStatus == 2 || inflation.HistoryRateStatus == null">trending_flat</span>
                                                <span class="text-muted mx-1">{{inflation.Date}}</span>
                                                <span class="mr-50 bg-light-success rounded px-50 ">
                                                    <short-text text="Fiyat Yansıma Oranı"></short-text>: {{inflation.CalculatedTufeAndUfeRate}}%
                                                </span>
                                                <span class="mr-50">
                                                    <short-text text="Tüfe"></short-text>: {{inflation.TufeRate}}% - 
                                                    <short-text text="Üfe"></short-text>: {{inflation.UfeRate}}%
                                                </span>
                                                <span class="material-icons-round text-primary" v-if="inflation.IsLastUpdated">verified</span>
                                            </div>
                                        </li>
                                    </ul>
                                </template>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 mt-1">
                        <div class="alert border mb-0">
                            <div class="alert-body">
                                <h5>Güncel Fiyatlar</h5>
                                <div class="table-responsive mb-0">
                                    <table class="table table-bordered table-sm">
                                        <thead>
                                            <tr>
                                                <th colspan="3" class="text-center bg-light-primary">Başlangıç</th>
                                                <th colspan="3" class="text-center bg-light-success">Bitiş</th>
                                                <th colspan="3" class="text-center bg-light-info">Tutar</th>
                                            </tr>
                                            <tr>
                                                <th>İl</th>
                                                <th>İlçe</th>
                                                <th>Mahalle</th>
                                                <th>İl</th>
                                                <th>İlçe</th>
                                                <th>Mahalle</th>
                                                <th>Tır/Treyler (TL)</th>
                                                <th>Kırkayak (TL)</th>
                                                <th>Kamyon (TL)</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <template v-if="$safe(detail,'PriceHistories') && detail.PriceHistories.length > 0">
                                                <template v-for="(route,index) in detail.PriceHistories" >
                                                    <tr :key="index">
                                                        <td>{{route.StartProvinceName || "-"}}</td>
                                                        <td>{{route.StartDistrictName || "-"}}</td>
                                                        <td>{{route.StartNeighbourhoodName || "-"}}</td>
                                                        <td>{{route.EndProvinceName || "-"}}</td>
                                                        <td>{{route.EndDistrictName || "-"}}</td>
                                                        <td>{{route.EndNeighbourhoodName || "-"}}</td>
                                                        <td>{{route.TreylerRoutePriceStr || "-"}}</td>
                                                        <td>{{route.KirkayakRoutePriceStr || "-"}}</td>
                                                        <td>{{route.KamyonRoutePriceStr || "-"}}</td>
                                                    </tr>
                                                </template>
                                            </template>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </b-card>
        </b-overlay>
    </div>
</template>

<script>
import { BCard,BOverlay } from 'bootstrap-vue'
import ShortText from '@/components/ShortText.vue'
import AgreementApi from '@/api/agreement'
import AgreementDetailPriceHistoryGraph from './components/AgreementDetailPriceHistoryGraph.vue'

export default {
    components:{
        BCard,
        BOverlay,
        AgreementDetailPriceHistoryGraph,
        ShortText
    },
    data(){
        return{
            loading:false,
            id:this.$route.params.id,
            detail:{}
        }
    },
    mounted(){
        this.getDetail()
    },
    methods:{
        back(){
            this.$router.push({name:'agreement'})
        },
        getDetail(){
            this.loading = true
            AgreementApi.Detail(this.id).then(res=>{
                this.loading = false
                this.detail = res.data.Data
            }).catch(err=>{
                this.loading = false
            })
        }
    }
}
</script>

<style>
.change-rate{
    font-size: 0.85rem;
}
</style>